export const LICHESS_URL = "https://lichess.org";
export const CHESS_COM_URL = "https://api.chess.com";
export const initialFen =
  "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1";
